import {
    Datagrid,
    TextField,
    ListProps,
    DateField,
    TextInput,
    BooleanField,
    DateInput,
} from "react-admin";
import { CustomFileField } from "../../components/CustomFIleField";
import { CustomList } from "../../components/CustomList";
import { SubjectField } from "../../components/SubjectField";
import { GoToDeliveriesButton } from "../../components/GoToDeliveriesButton";
import { useOptionsResource } from "../../shared/hooks/useOptionsResource";
import { initField, getDefaultListProps } from "../../shared/utils";
import { ReferenceInputSubject } from "../../components/reference-inputs/ReferenceInputSubject";
import {IdentifierField} from "../../components/IdentifierField";

export const ImportFunctionList = (props: ListProps) => {
    const { data: options } = useOptionsResource("GET");
    const filters = options
        ? [
            <TextInput {...initField("id", options)} />,
            <ReferenceInputSubject
                {...initField("client", options)}
                filter={{ type: "client" }}
                label="Cliente"
                alwaysOn
            />,
        ]
        : [];
    return options ? (
        <CustomList
            filters={filters}
            {...getDefaultListProps(props)}
            sort={{ field: "id", order: "DESC" }}
        >
            <Datagrid>
                <IdentifierField {...initField("id", options)} />
                <SubjectField {...initField("client", options)} label={"Cliente"} />
                <BooleanField source="sum_new_service" label="Accorpa righe" />
                <BooleanField source="add_note_rows" label="Righe nota" />
            </Datagrid>
        </CustomList>
    ) : null;
};
